angular
    .module('theme.core.panels', [])
    .config(() => {})
